module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about"
  }, [_c('Tab', {
    ref: "tab",
    class: {
      blur: _vm.isSearch, 'swiper-bg': _vm.hasBg
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main",
    class: {
      blur: _vm.isSearch
    },
    on: {
      "mouseover": _vm.tabMiss
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('Search', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSearch),
      expression: "isSearch"
    }]
  }), _vm._v(" "), (_vm.mapShow) ? _c('navigationsMap') : _vm._e(), _vm._v(" "), _c('bottom-text')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a48c6c2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pc/about/index.vue
// module id = 1293
// module chunks = 14